import { normalizeReferralStatus, REFERRAL_STATUS } from './referralStatus'

export enum InstanceType {
  Prd = 'prd',
  Dev = 'dev',
  Local = 'local',
}

export function getInstanceType(): InstanceType {
  if (window.location.hostname === 'www.techferral.com') {
    return InstanceType.Prd
  } else if (window.location.hostname === 'dev.techferral.com') {
    return InstanceType.Dev
  } else {
    return InstanceType.Local
  }
}

export function getBaseUrl(): string {
  const instanceType = getInstanceType()

  switch (instanceType) {
    case InstanceType.Prd:
      return 'https://www.techferral.com'
    case InstanceType.Dev:
      return 'https://dev.techferral.com'
    case InstanceType.Local:
      return 'http://localhost:3000'
    default:
      return 'https://www.techferral.com'
  }
}

export function getHumanTimeFromUnixTime(unixTime: number): string {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }

  const date = new Date(unixTime)
  return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '')
}

export function debounce<T extends unknown[], U>(
  callback: (...args: T) => PromiseLike<U> | U,
  wait: number,
) {
  let timer: NodeJS.Timeout

  return (...args: T): Promise<U> => {
    clearTimeout(timer)
    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(callback(...args)), wait)
    })
  }
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export const getReferralStatusColor = (status: string): string => {
  let color: 'green' | 'blue' | 'orange' | 'red'

  const normalizedStatus = normalizeReferralStatus(status)

  switch (normalizedStatus) {
    case REFERRAL_STATUS.PENDING:
      color = 'orange'
      break
    case REFERRAL_STATUS.JOB_COMPLETE:
      color = 'green'
      break
    case REFERRAL_STATUS.APPOINTMENT_COMPLETE:
      color = 'blue'
      break
    case REFERRAL_STATUS.CANCELLED:
      color = 'red'
      break
    default:
      color = 'blue'
  }

  return color
}

export function useQueryParams<T>(): T {
  return Object.fromEntries(new URLSearchParams(window.location.search)) as T
}
